import httpClient from '../httpClient';
import {
  CreateArchiveFormValues,
  DataRoomArchive,
} from '../../subrouters/Settings/pages/SetupPage/components/Snapshots/types';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';
import { FilePreview } from 'models/File';

function createArchive(dataRoomId: string, values: CreateArchiveFormValues) {
  return httpClient.post<DataRoomArchive>('data-room-archives', {
    dataRoomId,
    ...values,
  });
}

function getArchives(dataRoomId: string, params?: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomArchive>>(
    `data-room-archives/data-rooms/${dataRoomId}`,
    { params },
  );
}

function getArchiveInstance(dataRoomArchiveId: string, instanceId: string) {
  return httpClient.get<FilePreview>(
    `data-room-archives/${dataRoomArchiveId}/data-room-archive-instance/${instanceId}`,
  );
}

function shareArchiveInstance(dataRoomArchiveId: string) {
  return httpClient.post<DataRoomArchive>(
    `data-room-archives/${dataRoomArchiveId}/share-index`,
  );
}

export default {
  createArchive,
  getArchives,
  getArchiveInstance,
  shareArchiveInstance,
};
